import { ethers } from 'ethers';
import { LzChainIdFromChainName } from './types';
import { Address } from 'viem';

export const DEFAULT_FEE_DECIMALS = 4;
export const DEFAULT_TOKEN_DECIMALS = 18;

export const lzDefaultAdapterParams = ethers.utils.solidityPack(
  ['uint16', 'uint256'],
  [1, 200000]
) as Address; // default adapterParams example

// list of endpoints https://docs.layerzero.network/v2/developers/evm/technical-reference/deployed-contracts
export const layerZeroChainIds: LzChainIdFromChainName = {
  ethereum: 101,
  bsc: 102,
  avalanche: 106,
  polygon: 109,
  arbitrum: 110,
  optimism: 111,
  fantom: 112,
  goerli: 10121,
  'bsc-testnet': 10102,
  fuji: 10106,
  mumbai: 10109,
  'arbitrum-goerli': 10143,
  'optimism-goerli': 10132,
  'fantom-testnet': 10112,
  'meter-testnet': 10156,
  'zksync-testnet': 10165,
};

export const layerZeroChainIdsByChainId: LzChainIdFromChainName = {
  1: 101,
  56: 102,
  43114: 106,
  137: 109,
  42161: 110,
  10: 111,
  250: 112,
  8453: 184,
  //  testnets below
  5: 10121, // goerli
  97: 10102, // bsc testnet
  11155111: 10161, // sepolia testnet
  43113: 10106,
  80001: 10109,
  421611: 10143,
  420: 10132,
  4002: 10112,
  1337: 10156,
  333: 10165,
  31438: 101, // wont work here to allow app to load on forked net...
  31439: 102, // wont work here to allow app to load on forked net...
  17000: 10217,
  84532: 10245,
};

export const chainIdsByLayerZeroChainId: Record<number, number> = {
  101: 1,
  102: 56,
  106: 43114,
  109: 137,
  110: 42161,
  111: 10,
  112: 250,
  // testnets below
  10121: 5,
  10102: 97,
  10106: 43113,
  10109: 80001,
  10143: 421611,
  10132: 420,
  10112: 4002,
  10156: 1337,
  10161: 11155111,
  10165: 333,
};
